module.exports = __webpack_public_path__ + "static/media/feuerloescher_frage.a51c9552.jpg";